
import { useState, useEffect } from "react";
import { Briefcase } from "lucide-react";
import { Link } from "react-router-dom";
import { Button } from "@/components/ui/button";
import { supabase } from "@/integrations/supabase/client";

interface Job {
  id: string;
  title: string;
  description?: string | null;
  contact_id?: string | null;
}

interface LinkedJobsProps {
  contactId: string;
  companyId: string;
}

export const LinkedJobs = ({ contactId, companyId }: LinkedJobsProps) => {
  const [linkedJobs, setLinkedJobs] = useState<Job[]>([]);
  const [loading, setLoading] = useState(false);
  
  useEffect(() => {
    if (contactId) {
      fetchLinkedJobs();
    }
  }, [contactId, companyId]);
  
  const fetchLinkedJobs = async () => {
    try {
      setLoading(true);
      const { data, error } = await supabase
        .from('jobs')
        .select('id, title, description')
        .eq('company_id', companyId)
        .eq('contact_id', contactId);
      
      if (error) throw error;
      
      setLinkedJobs(data || []);
    } catch (error) {
      console.error("Error fetching linked jobs:", error);
    } finally {
      setLoading(false);
    }
  };
  
  return (
    <div>
      <h4 className="font-medium mb-3 flex items-center">
        <Briefcase className="h-5 w-5 text-gray-400 mr-2" />
        Linked Job Positions
      </h4>
      
      {loading ? (
        <div className="animate-pulse space-y-2">
          {[1, 2].map((i) => (
            <div key={i} className="h-10 bg-gray-200 rounded-md"></div>
          ))}
        </div>
      ) : linkedJobs.length > 0 ? (
        <div className="space-y-2 pl-7">
          {linkedJobs.map(job => (
            <div key={job.id} className="flex items-center justify-between border rounded-md p-2">
              <span>{job.title}</span>
              <Link to={`/jobs/${job.id}`}>
                <Button variant="outline" size="sm">View</Button>
              </Link>
            </div>
          ))}
        </div>
      ) : (
        <p className="text-gray-500 pl-7">No linked job positions</p>
      )}
    </div>
  );
};
